import { makeAutoObservable } from 'mobx';

type OverviewPanelProjectState = {
	isOpen: boolean;
	folderID: number | null;
}

export type OverviewPanelStoreSerialization = {
	[projectID: number]: OverviewPanelProjectState;
}

type OverviewPanelState = {
	[projectID: number]: OverviewPanelProjectState;
}

export default class OverviewPanelStore {
	state: OverviewPanelState = {};

	constructor() {
		makeAutoObservable( this );
	}

	private getProjectState( projectID: number ) {
		if ( !this.state[ projectID ] ) {
			this.state[ projectID ] = { isOpen: false, folderID: null };
		}
		return this.state[ projectID ];
	}

	isOpen( projectID: number ): boolean {
		return this.getProjectState( projectID ).isOpen;
	}

	getFolderID( projectID: number ): number | null {
		return this.getProjectState( projectID ).folderID;
	}

	setOverviewSidePanelOpen( projectID: number, isOpen: boolean, folderID: number | null = null ) {
		const projectState = this.getProjectState( projectID );
		projectState.isOpen = isOpen;
		projectState.folderID = folderID;
	}

	closeOverviewSidePanel( projectID: number ) {
		this.setOverviewSidePanelOpen( projectID, false, null );
	}

	serialize(): OverviewPanelStoreSerialization {
		return { ...this.state };
	}

	hydrate( serialization: OverviewPanelStoreSerialization ) {
		Object.entries( serialization ).forEach( ( [ projectID, projectState ] ) => {
			this.state[ Number( projectID ) ] = projectState;
		} );
	}

	clear() {
		this.state = {};
	}
}
